export default function SectionLabel({ children }) {
  return (
    <div className="flex items-center gap-2.5 mb-5">
      <span className="font-glacial-bold text-[11px] text-mm-gold/70 uppercase tracking-[0.15em]">
        {children}
      </span>
      <div className="flex-1 h-px bg-mm-border" />
    </div>
  )
}
